<template>
    <div :data-name="name"
         class="mini-dashlet elevation-2">
        <!-- Div must be here to prevent content losing padding when being moved by dragula -->
        <div class="mini-dashlet-content">
            <div class="mini-dashlet-title">
                <div class="wrap-text">
                    <span>{{ title }}</span>
                </div>
                <input v-if="showInput"
                       v-model="showCount"
                       max="20"
                       min="1"
                       type="number">
            </div>

            <i v-if="icon"
               :class="icon"
               class="fas" />

            <grid v-if="showGrid"
                  :cols="numGridCols"
                  :show-count="showCount" />
        </div>
    </div>
</template>

<script>
import grid from './mini-grid-count'

export default {
    components: {
        grid
    },
    props: {
        name: String,
        settings: {
            type: [Object, Array],
            default: () => {
            }
        }
    },
    computed: {
        title() {
            switch (this.name) {
                case 'clients-map':
                    return Lang.langGet('Client Map')
                case 'clients-location-plan':
                    return Lang.langGet('Location Plan')
                case 'clients-list':
                    return Lang.langGet('Client Overview')
                case 'publish':
                    return Lang.langGet('Publish')
                case 'mediapool':
                    return Lang.langGet('Mediapool')
                case 'journal':
                    return Lang.langGet('Recent Activities')
                case 'storage':
                    return Lang.langGet('Storage utilization')
                default:
                    return this.name
            }
        },
        showGrid() {
            switch (this.name) {
                case 'clients-map':
                case 'clients-location-plan':
                    return false
                default:
                    return true
            }
        },
        numGridCols() {
            return this.name === 'mediapool' ? 4 : 1
        },
        showInput() {
            switch (this.name) {
                case 'clients-list':
                case 'publish':
                case 'mediapool':
                case 'journal':
                    return true
                default :
                    return false
            }
        },
        icon() {
            switch (this.name) {
                case 'clients-map':
                    return 'fa-map-location-dot fa-3x'
                case 'clients-location-plan':
                    return 'fa-chart-tree-map fa-3x'
                case 'publish':
                    return 'fa-filter fa-xl'
            }
        },
        showCount: {
            get() {
                return (this.settings && this.settings['show-count']) ? Math.max(Math.min(parseInt(this.settings['show-count']), 20), 1) : 1
            },
            set(val) {
                if (val >= 1 && val <= 20) {
                    this.settings['show-count'] = val
                } else if (val > 20) {
                    this.settings['show-count'] = 20
                } else if (val !== '') {
                    this.settings['show-count'] = 1
                }
            }
        }
    }
}
</script>
